import { Environment } from '@galaxy/core';

// Ecwid
export const ecwidMonthlyAppId = {
  [Environment.DEMO]: 'MP-GHW8ZCK42QS8M775BBQ42KTXJTBVM8CX',
  [Environment.PROD]: 'MP-LX2JJS5GKGDZ8668J52LGNBSQVW2P5XM',
};

export const ecwidYearlyAppId = {
  [Environment.DEMO]: 'MP-7CKHFRLNRVLPWTB8P37HD8XD4R2LMVJR',
  [Environment.PROD]: 'MP-TVFNHNFZVGBC86QV2K6LWTDFKVXK2BB5',
};

export const ecwidUrl = {
  [Environment.DEMO]: 'https://cloud-blue-demo.apigateway.co',
  [Environment.PROD]: 'https://cloud-blue-prod.apigateway.co',
};

// Constant Contact
export const constantContactAppId = {
  [Environment.DEMO]: 'MP-TCG3QC4PZJTVV46QVRT342JHQ64XBL8Z',
  [Environment.PROD]: 'MP-745V5GBKVRZ3DHP6D8P8RT58KM7SHDZS',
};

export const constantContactUrl = {
  [Environment.DEMO]: 'https://constant-contact-demo.apigateway.co',
  [Environment.PROD]: 'https://constant-contact-prod.apigateway.co',
};

// Google Workspace
export const googleWorkspaceBusinessBasicAppId = {
  [Environment.DEMO]: 'MP-6XDHVMQ84K4THNNP2Z7W2GC28VLHRC4Q',
  [Environment.PROD]: 'MP-XBHPSLDBHZ8Q8F57P43DPKL6SPHKHHMS',
};

export const googleWorkspaceBusinessBasicSeatAddonId = {
  [Environment.DEMO]: 'A-JMJX3KJPT5',
  [Environment.PROD]: 'A-PSZPWNCFWM',
};

export const googleWorkspaceBusinessStandardAppId = {
  [Environment.DEMO]: 'MP-GNWSMJS4BJB4Z8RZWZ8SXW6J4HP32KJ3',
  [Environment.PROD]: 'MP-BJ37LGNT37SDN6LR7D46MPP7CBG82MN6',
};

export const googleWorkspaceBusinessStandardSeatAddonId = {
  [Environment.DEMO]: 'A-JZTKNPKBDL',
  [Environment.PROD]: 'A-DH5P2QL4MG',
};

export const googleWorkspaceBusinessPlusAppId = {
  [Environment.DEMO]: 'MP-8PS55DCP5DKMDPDHHPWSFPD8XCM44324',
  [Environment.PROD]: 'MP-S2RJ778BSJR7KXFSS775BHCX383CJVSV',
};

export const googleWorkspaceBusinessPlusSeatAddonId = {
  [Environment.DEMO]: 'A-XMF5CQJPJQ',
  [Environment.PROD]: 'A-3MC43W3SXM',
};

export const googleWorkspaceEnterpriseEssentialsAppId = {
  [Environment.DEMO]: 'MP-35GSNMZC352XWQHN2Q588WVLW62SM27V',
  [Environment.PROD]: 'MP-3C37DKQZ3LFVKBXJC4222KNZQPH6XCW7',
};

export const googleWorkspaceEnterpriseEssentialsSeatAddonId = {
  [Environment.DEMO]: 'A-6DCL4PXXBV',
  [Environment.PROD]: 'A-5BGKHQFTHV',
};

export const googleWorkspaceEnterpriseStandardAppId = {
  [Environment.DEMO]: 'MP-453NG65TC8S72CQ3NTQ4WTS3DWLLXQQH',
  [Environment.PROD]: 'MP-MTFJDXGF8M2FFBNR282Q4SSCLPJJTZ36',
};

export const googleWorkspaceEnterpriseStandardSeatAddonId = {
  [Environment.DEMO]: 'A-Q8BVK5NCWJ',
  [Environment.PROD]: 'A-Z47MQDJNC6',
};

export const googleWorkspaceEnterprisePlusAppId = {
  [Environment.DEMO]: 'MP-VDNQPHCTCMHVMSNW87R8N3NRTS4HC6LV',
  [Environment.PROD]: 'MP-FCZGBZM4ZNSGV26CCKVB6GM4F8T5Q6HG',
};

export const googleWorkspaceEnterprisePlusSeatAddonId = {
  [Environment.DEMO]: 'A-T5LTKP7ZTV',
  [Environment.PROD]: 'A-QH5H53VTKQ',
};

export const googleTransferAppId = {
  [Environment.DEMO]: 'MP-7TMH5K8N7KNNRZ5NC4RNNS2JFK64HMNC',
  [Environment.PROD]: 'MP-LMVNT4HKZCXTVDFMVT62Q6VB3ZJGNQC6',
};

export const googleWorkspaceUrl = {
  [Environment.DEMO]: 'https://google-admin-demo.apigateway.co',
  [Environment.PROD]: 'https://google-admin-prod.apigateway.co',
};

export const GoogleWorkspaceBusinessBasicAppIds: string[] = [
  googleWorkspaceBusinessBasicAppId[Environment.DEMO],
  googleWorkspaceBusinessBasicAppId[Environment.PROD],
];
export const GoogleWorkspaceBusinessBasicSeatAddonIds: string[] = [
  googleWorkspaceBusinessBasicSeatAddonId[Environment.DEMO],
  googleWorkspaceBusinessBasicSeatAddonId[Environment.PROD],
];
export const GoogleWorkspaceBusinessStandardAppIds: string[] = [
  googleWorkspaceBusinessStandardAppId[Environment.DEMO],
  googleWorkspaceBusinessStandardAppId[Environment.PROD],
];
export const GoogleWorkspaceBusinessStandardSeatAddonIds: string[] = [
  googleWorkspaceBusinessStandardSeatAddonId[Environment.DEMO],
  googleWorkspaceBusinessStandardSeatAddonId[Environment.PROD],
];
export const GoogleWorkspaceBusinessPlusAppIds: string[] = [
  googleWorkspaceBusinessPlusAppId[Environment.DEMO],
  googleWorkspaceBusinessPlusAppId[Environment.PROD],
];
export const GoogleWorkspaceBusinessPlusSeatAddonIds: string[] = [
  googleWorkspaceBusinessPlusSeatAddonId[Environment.DEMO],
  googleWorkspaceBusinessPlusSeatAddonId[Environment.PROD],
];
export const GoogleWorkspaceEnterpriseEssentialsAppIds: string[] = [
  googleWorkspaceEnterpriseEssentialsAppId[Environment.DEMO],
  googleWorkspaceEnterpriseEssentialsAppId[Environment.PROD],
];
export const GoogleWorkspaceEnterpriseEssentialsSeatAddonIds: string[] = [
  googleWorkspaceEnterpriseEssentialsSeatAddonId[Environment.DEMO],
  googleWorkspaceEnterpriseEssentialsSeatAddonId[Environment.PROD],
];
export const GoogleWorkspaceEnterpriseStandardAppIds: string[] = [
  googleWorkspaceEnterpriseStandardAppId[Environment.DEMO],
  googleWorkspaceEnterpriseStandardAppId[Environment.PROD],
];
export const GoogleWorkspaceEnterpriseStandardSeatAddonIds: string[] = [
  googleWorkspaceEnterpriseStandardSeatAddonId[Environment.DEMO],
  googleWorkspaceEnterpriseStandardSeatAddonId[Environment.PROD],
];
export const GoogleWorkspaceEnterprisePlusAppIds: string[] = [
  googleWorkspaceEnterprisePlusAppId[Environment.DEMO],
  googleWorkspaceEnterprisePlusAppId[Environment.PROD],
];
export const GoogleWorkspaceEnterprisePlusSeatAddonIds: string[] = [
  googleWorkspaceEnterprisePlusSeatAddonId[Environment.DEMO],
  googleWorkspaceEnterprisePlusSeatAddonId[Environment.PROD],
];
export const GoogleTransferAppIds: string[] = [
  googleTransferAppId[Environment.DEMO],
  googleTransferAppId[Environment.PROD],
];
export const GoogleWorkspaceAppIds: string[] = GoogleWorkspaceBusinessBasicAppIds.concat(
  GoogleWorkspaceBusinessStandardAppIds,
  GoogleWorkspaceBusinessPlusAppIds,
  GoogleTransferAppIds,
  GoogleWorkspaceEnterpriseEssentialsAppIds,
  GoogleWorkspaceEnterpriseStandardAppIds,
  GoogleWorkspaceEnterprisePlusAppIds,
);
export const GoogleWorkspaceSeatAddonIds: string[] = GoogleWorkspaceBusinessBasicSeatAddonIds.concat(
  GoogleWorkspaceBusinessStandardSeatAddonIds,
  GoogleWorkspaceBusinessPlusSeatAddonIds,
  GoogleWorkspaceEnterpriseEssentialsSeatAddonIds,
  GoogleWorkspaceEnterpriseStandardSeatAddonIds,
  GoogleWorkspaceEnterprisePlusSeatAddonIds,
);

// Godaddy
export const godaddyAppId = {
  [Environment.DEMO]: 'MP-NNTJMBF6HPXR5XXC2JKCFWKJ64VZLBFQ',
  [Environment.PROD]: 'MP-4TMLZSQ5FMJQX5T75TPC43FQBWD2VXLB',
};

export const whitelabelDomainAppId = {
  [Environment.DEMO]: 'MP-ZZC3ZP6WSV3W5VL4HS5SKJZL44MPR5XK',
  [Environment.PROD]: 'MP-L3DHRP5Z2RP4QVWLLTQGJLLVSH232WR5',
};

export const godaddyUrl = {
  [Environment.DEMO]: 'https://domain-manager-demo.apigateway.co',
  [Environment.PROD]: 'https://domain-manager-prod.apigateway.co',
};

// Microsoft Office
export const enum msOfficePlan {
  CUSTOMER = 3,
}

export const msOfficeAppId = {
  [msOfficePlan.CUSTOMER]: {
    [Environment.DEMO]: 'MP-GXWJBHH6PQ5HDCDXFQ2ZP4D276JCJLKH',
    [Environment.PROD]: 'MP-MWTXLV4WDG2QCHSF2DR4JRSC4WK32DDG',
  },
};

export const msOfficeRequestResellerRelationshipAppId = {
  [Environment.DEMO]: 'MP-XGRN8XVPKGDWSKXL64DNCSQDNNQQHTGJ',
  [Environment.PROD]: 'MP-5VBL5CBMLSKN4D3W58PKZJTSVD7G8GV7',
};

export const msOfficeUrl = {
  [Environment.DEMO]: 'https://ms-office-api-demo.apigateway.co',
  [Environment.PROD]: 'https://ms-office-prod.apigateway.co',
};

export const DynamicOrderFormAppIds: string[] = [
  godaddyAppId[Environment.DEMO],
  godaddyAppId[Environment.PROD],
  whitelabelDomainAppId[Environment.DEMO],
  whitelabelDomainAppId[Environment.PROD],
];

export const Office365AppIds: string[] = [
  msOfficeAppId[msOfficePlan.CUSTOMER][Environment.DEMO],
  msOfficeAppId[msOfficePlan.CUSTOMER][Environment.PROD],
];

// ActiveCampaign
export const activeCampaignDemoAppId = 'MP-MCLBF8TMSMLCQ5W72LNHQV5XVW4KC2MX';
export const activeCampaignProdAppId = 'MP-JP83X2HKPVP6NLVKGMRP7Z5N38HDKBHR';
export const activeCampaignDemoAppIdV2 = 'MP-XWWSC2TZNXML5CSXKQGCL7PL5F38MZRB';
export const activeCampaignProdAppIdV2 = 'MP-3F7ZSKDVN78XB7XN2VGJKNVH86QTBKSQ';

export const activeCampaignAppId = {
  [Environment.DEMO]: activeCampaignDemoAppId,
  [Environment.PROD]: activeCampaignProdAppId,
};

export const activeCampaignAppIdV2 = {
  [Environment.DEMO]: activeCampaignDemoAppIdV2,
  [Environment.PROD]: activeCampaignProdAppIdV2,
};

export const activeCampaignAppIdList = [
  activeCampaignDemoAppId,
  activeCampaignProdAppId,
  activeCampaignDemoAppIdV2,
  activeCampaignProdAppIdV2,
];

export const activeCampaignUrl = {
  [Environment.DEMO]: 'https://active-campaign-api-demo.apigateway.co',
  [Environment.PROD]: 'https://active-campaign-api-prod.apigateway.co',
};

export enum PlanType {
  Lite = 'Lite',
  Plus = 'Plus',
  Pro = 'Pro',
  Enterprise = 'Enterprise',
}

export enum ContactLimit {
  limit500 = '500',
  limit1000 = '1,000',
  limit2500 = '2,500',
  limit5000 = '5,000',
  limit10000 = '10,000',
  limit25000 = '25,000',
  limit50000 = '50,000',
  limit75000 = '75,000',
  limit100000 = '100,000',
  limit150000 = '150,000',
  limit200000 = '200,000',
  limit250000 = '250,000',
  limit300000 = '300,000',
  limit800000 = '800,000',
}

export interface ActiveCampaignPlanTypeAndLimit {
  planType: PlanType;
  contactLimit: ContactLimit;
}

export const ActiveCampaignEditionIds = new Map<Environment, Map<string, ActiveCampaignPlanTypeAndLimit>>([
  [
    Environment.DEMO,
    new Map<string, ActiveCampaignPlanTypeAndLimit>([
      // Lite
      ['EDITION-KTBXB52B', { planType: PlanType.Lite, contactLimit: ContactLimit.limit500 }],
      ['EDITION-JQFH83P7', { planType: PlanType.Lite, contactLimit: ContactLimit.limit1000 }],
      ['EDITION-PQ3284QG', { planType: PlanType.Lite, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-J5R7WHX2', { planType: PlanType.Lite, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-43BCJ7PM', { planType: PlanType.Lite, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-NBJ4T68D', { planType: PlanType.Lite, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-RMKJHQBZ', { planType: PlanType.Lite, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-CPLT6LD6', { planType: PlanType.Lite, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-2NKXJ3QH', { planType: PlanType.Lite, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-QN2S8L36', { planType: PlanType.Lite, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-WBCT5VMR', { planType: PlanType.Lite, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-TT4BLD62', { planType: PlanType.Lite, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-KM5RDJQ3', { planType: PlanType.Lite, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-STHNB68N', { planType: PlanType.Lite, contactLimit: ContactLimit.limit800000 }],
      // Plus
      ['EDITION-LKTT3ZR2', { planType: PlanType.Plus, contactLimit: ContactLimit.limit1000 }],
      ['EDITION-QW6GLQ3K', { planType: PlanType.Plus, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-RDNFFWRN', { planType: PlanType.Plus, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-ZFSRJSQG', { planType: PlanType.Plus, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-SKJTVBSM', { planType: PlanType.Plus, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-RRX5G7FX', { planType: PlanType.Plus, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-H8ZHPWT2', { planType: PlanType.Plus, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-V88PPHHM', { planType: PlanType.Plus, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-TRB4ZMBM', { planType: PlanType.Plus, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-5RP4RZ66', { planType: PlanType.Plus, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-RLP7HCBN', { planType: PlanType.Plus, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-SQ3WBZFN', { planType: PlanType.Plus, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-SMQN2JG5', { planType: PlanType.Plus, contactLimit: ContactLimit.limit800000 }],
      // Pro
      ['EDITION-VMW8XMLF', { planType: PlanType.Pro, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-GQ228LKM', { planType: PlanType.Pro, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-GWRRFCM6', { planType: PlanType.Pro, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-4JW4T2LK', { planType: PlanType.Pro, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-5RCNQJRW', { planType: PlanType.Pro, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-V4ZRRQQK', { planType: PlanType.Pro, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-7ZN3JB34', { planType: PlanType.Pro, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-HLKFHJM6', { planType: PlanType.Pro, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-RV8FR3T7', { planType: PlanType.Pro, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-JGG6MCLP', { planType: PlanType.Pro, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-T3ZP8LQQ', { planType: PlanType.Pro, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-V7W3P3X2', { planType: PlanType.Pro, contactLimit: ContactLimit.limit800000 }],

      // Enterprise
      ['EDITION-JP88KM37', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-RB8Z2QRN', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-6JHRK2LK', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-PBVPW5RP', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-RJQ8XWGT', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-4XC7ZXVT', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-VRSS2KF2', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-WGZBQ3JL', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-KRWBN367', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-322RVFQF', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-562BC5NS', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-NWKC42C4', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit800000 }],
    ]),
  ],
  [
    Environment.PROD,
    new Map<string, ActiveCampaignPlanTypeAndLimit>([
      // Lite
      ['EDITION-GTP5PH5K', { planType: PlanType.Lite, contactLimit: ContactLimit.limit500 }],
      ['EDITION-RSS853Q6', { planType: PlanType.Lite, contactLimit: ContactLimit.limit1000 }],
      ['EDITION-DCXTQNNF', { planType: PlanType.Lite, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-MGS8GKFV', { planType: PlanType.Lite, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-MT6MBK77', { planType: PlanType.Lite, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-RHPVKGSZ', { planType: PlanType.Lite, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-VJZFGMFH', { planType: PlanType.Lite, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-XV4M32NK', { planType: PlanType.Lite, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-B2XP5HTX', { planType: PlanType.Lite, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-BFVLDHDK', { planType: PlanType.Lite, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-5VKT6BHW', { planType: PlanType.Lite, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-24K7LRLR', { planType: PlanType.Lite, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-GFV5T3HG', { planType: PlanType.Lite, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-PZGGKMC2', { planType: PlanType.Lite, contactLimit: ContactLimit.limit800000 }],
      // Plus
      ['EDITION-LKTT3ZR2', { planType: PlanType.Plus, contactLimit: ContactLimit.limit1000 }],
      ['EDITION-6F2ZXNZP', { planType: PlanType.Plus, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-XZ3ZH2XN', { planType: PlanType.Plus, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-4TZVJ4BL', { planType: PlanType.Plus, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-GHG7MTRF', { planType: PlanType.Plus, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-KBW888NC', { planType: PlanType.Plus, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-FV28RPVJ', { planType: PlanType.Plus, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-6K2X6LGV', { planType: PlanType.Plus, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-PVLCJFSM', { planType: PlanType.Plus, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-GVVS6XZ5', { planType: PlanType.Plus, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-7PSFP8SM', { planType: PlanType.Plus, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-KK7RZFF6', { planType: PlanType.Plus, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-4GZM5Q2L', { planType: PlanType.Plus, contactLimit: ContactLimit.limit800000 }],
      // Pro
      ['EDITION-B6R4LC73', { planType: PlanType.Pro, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-QWN6B5KB', { planType: PlanType.Pro, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-VHFKKMPQ', { planType: PlanType.Pro, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-PK22777F', { planType: PlanType.Pro, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-HFLN87S7', { planType: PlanType.Pro, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-NS8RR7CF', { planType: PlanType.Pro, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-GL2HC6XQ', { planType: PlanType.Pro, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-4878W7V7', { planType: PlanType.Pro, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-HL7Z3BJF', { planType: PlanType.Pro, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-XGCMLHCS', { planType: PlanType.Pro, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-FZW42DR6', { planType: PlanType.Pro, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-NNK6S6CK', { planType: PlanType.Pro, contactLimit: ContactLimit.limit800000 }],
      // Enterprise
      ['EDITION-QKRDJKG3', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-NX4QJPQF', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-HN58HJPP', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-3J5RKZKS', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-LLBK2NMP', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-TCRZ58T4', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-LDNLM8N4', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-63CGKG8N', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-SBLV6JD6', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-4X8CMMP2', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-M2FT5TNV', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-VFLGN647', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit800000 }],
    ]),
  ],
]);

export const ActiveCampaignEditionIdsV2 = new Map<Environment, Map<string, ActiveCampaignPlanTypeAndLimit>>([
  [
    Environment.DEMO,
    new Map<string, ActiveCampaignPlanTypeAndLimit>([
      // Plus
      ['EDITION-Q4RD2TL7', { planType: PlanType.Plus, contactLimit: ContactLimit.limit1000 }],
      ['EDITION-FQDSJ5R8', { planType: PlanType.Plus, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-V624ZF3C', { planType: PlanType.Plus, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-ZGJ2RS6J', { planType: PlanType.Plus, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-KMZSB4D4', { planType: PlanType.Plus, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-V5D5VNBH', { planType: PlanType.Plus, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-GS3GRRR8', { planType: PlanType.Plus, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-HMSX7W5J', { planType: PlanType.Plus, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-SGR65DMK', { planType: PlanType.Plus, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-PPZN8S7H', { planType: PlanType.Plus, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-CKQM8FTJ', { planType: PlanType.Plus, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-LP3MZBGH', { planType: PlanType.Plus, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-NCQJ8RG5', { planType: PlanType.Plus, contactLimit: ContactLimit.limit800000 }],
      // Pro
      ['EDITION-RQ83CZQ4', { planType: PlanType.Pro, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-SGZJPSTG', { planType: PlanType.Pro, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-DN3VL8VG', { planType: PlanType.Pro, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-W4TWX67J', { planType: PlanType.Pro, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-DCVNPPNW', { planType: PlanType.Pro, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-GQFD2DDF', { planType: PlanType.Pro, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-73SC62T6', { planType: PlanType.Pro, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-8QSC6NXN', { planType: PlanType.Pro, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-MLXXR4QR', { planType: PlanType.Pro, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-NTJWTG8Q', { planType: PlanType.Pro, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-WBTVQLJ6', { planType: PlanType.Pro, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-BRCXSDBB', { planType: PlanType.Pro, contactLimit: ContactLimit.limit800000 }],

      // Enterprise
      ['EDITION-R43LZD7F', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-5PTW4W4M', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-QF6G5QTR', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-GLXNVCDN', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-G6MX4LLV', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-X6BMQTNB', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-GLPCPGTX', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-FRPTCWG4', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-QN875MTR', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-S7XGJSZ8', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-XJPRF8CQ', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-JRKLK5RR', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit800000 }],
    ]),
  ],
  [
    Environment.PROD,
    new Map<string, ActiveCampaignPlanTypeAndLimit>([
      // Plus
      ['EDITION-VWZWSCTP', { planType: PlanType.Plus, contactLimit: ContactLimit.limit1000 }],
      ['EDITION-BHGQBVDG', { planType: PlanType.Plus, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-68M8ZSV5', { planType: PlanType.Plus, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-7QSC84MF', { planType: PlanType.Plus, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-G2WPCHPQ', { planType: PlanType.Plus, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-QMDV67P2', { planType: PlanType.Plus, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-RSWP5LPG', { planType: PlanType.Plus, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-ZTR8RPCS', { planType: PlanType.Plus, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-LZRP6L5T', { planType: PlanType.Plus, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-G438DHK7', { planType: PlanType.Plus, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-PPLRKV7Z', { planType: PlanType.Plus, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-T8F2C5ZN', { planType: PlanType.Plus, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-7FZ83PP5', { planType: PlanType.Plus, contactLimit: ContactLimit.limit800000 }],
      // Pro
      ['EDITION-5225DH6V', { planType: PlanType.Pro, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-SNXN72JN', { planType: PlanType.Pro, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-7TN38SC4', { planType: PlanType.Pro, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-JMWVRXZ7', { planType: PlanType.Pro, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-L5JTSMDF', { planType: PlanType.Pro, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-LC3SLQVB', { planType: PlanType.Pro, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-37S3F2HB', { planType: PlanType.Pro, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-HQH382V5', { planType: PlanType.Pro, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-2CF28FMH', { planType: PlanType.Pro, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-NBFLX632', { planType: PlanType.Pro, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-CC25SJ8Q', { planType: PlanType.Pro, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-WVTW4Z7S', { planType: PlanType.Pro, contactLimit: ContactLimit.limit800000 }],
      // Enterprise
      ['EDITION-RHMZBJDN', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit2500 }],
      ['EDITION-4Z5VFRGB', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit5000 }],
      ['EDITION-VMJRMP68', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit10000 }],
      ['EDITION-CZRHVCRQ', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit25000 }],
      ['EDITION-NDH5V6PK', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit50000 }],
      ['EDITION-WGM2ZR58', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit75000 }],
      ['EDITION-4W6VLVW8', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit100000 }],
      ['EDITION-V5V2BF4N', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit150000 }],
      ['EDITION-GCDPD727', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit200000 }],
      ['EDITION-7RKXFZJN', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit250000 }],
      ['EDITION-ZS8JLQSL', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit300000 }],
      ['EDITION-WWXTHBGH', { planType: PlanType.Enterprise, contactLimit: ContactLimit.limit800000 }],
    ]),
  ],
]);

export function editionIdFromPlanTypeAndContactLimit(
  planType: PlanType,
  contactLimit: ContactLimit,
  env: Environment,
  useV2 = false,
): string {
  const activeCampaignEditionIds = useV2 ? ActiveCampaignEditionIdsV2 : ActiveCampaignEditionIds;
  const keyValuePair = Array.from(activeCampaignEditionIds.get(env).entries()).find(
    ([, v]) => v.planType === planType && v.contactLimit === contactLimit,
  );
  if (keyValuePair) {
    return keyValuePair[0];
  }
  return '';
}

export function planTypeAndContactLimitFromEditionId(
  editionId: string,
  env: Environment,
  useV2 = false,
): ActiveCampaignPlanTypeAndLimit {
  const activeCampaignEditionIds = useV2 ? ActiveCampaignEditionIdsV2 : ActiveCampaignEditionIds;
  return activeCampaignEditionIds.get(env).get(editionId);
}
